import { useI18n } from "@/lib/i18n";
import { Globe } from "lucide-react";

const LABELS = { fr: "FR", en: "EN", zh: "中", ru: "RU" };

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang, supported } = useI18n();

  return (
    <div
      className="inline-flex items-center gap-0.5 sm:gap-1 px-1.5 sm:px-2 py-1 rounded-full border"
      style={{ borderColor: "var(--c-border)", background: "var(--c-surface)" }}
      data-testid="lang-switcher"
    >
      <Globe size={12} style={{ color: "var(--c-text-soft)" }} className="hidden sm:inline-block"/>
      {supported.map((code) => {
        const active = lang === code;
        return (
          <button
            key={code}
            data-testid={`lang-${code}`}
            onClick={() => setLang(code)}
            className="text-[11px] font-semibold tracking-wider uppercase px-1.5 py-0.5 rounded transition-colors"
            style={{
              color: active ? "var(--c-primary)" : "var(--c-text-soft)",
              background: active ? "var(--c-accent)" : "transparent",
            }}
            aria-pressed={active}
            aria-label={`Switch to ${code.toUpperCase()}`}
          >
            {LABELS[code] || code}
          </button>
        );
      })}
      {compact ? null : null}
    </div>
  );
}
